import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafField } from '@cigna/leaf-web/lib/wc';

import '@cigna/leaf-web/lib/wc/components/field-note/field-note';

@Component({
  selector: 'cigna-leaf-field-note',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-field-note [isError]="isError" [isSuccess]="isSuccess"
      ><ng-content></ng-content
    ></leaf-field-note>
  `,
})
export class CignaLeafFieldNoteComponent {
  @Input() isError: LeafField['isError'];
  @Input() isSuccess: LeafField['isSuccess'];
}
